import { Function } from './Function';

export class Permission {
    constructor(id, listaProductos, listaCategorias, listaProgramas, funciones, allowPermisos) {
        this.id = id;
        this.productoId = 0;
        this.categoriaId = 0;
        this.programaId = 0;
        this.funciones = [];
        this.allowPermisos = false;

        this.listaProductos = listaProductos;
        this.listaCategorias = listaCategorias;
        this.listaProgramas = listaProgramas;
        this.listaFunciones = [];

        for (var i = 0; i < funciones.length; i++) {
            this.listaFunciones.push(new Function(funciones[i].Id, funciones[i].Descripcion));
        }
    }
}